export enum AuthNewLocalStorage {
    OAuthLoggedIn = 'OAuthLoggedIn',
}

export enum Web3AuthSteps {
    AddTwitterSuccess = 'add-twitter-success',
    CombineAccounts = 'combine-accounts',
    EmailActivation = 'email-activation',
    Entry = 'entry',
    ForgotPassword = 'forgot-password',
    ForgotPasswordConfirmation = 'forgot-password-confirmation',
    ResetPassword = 'reset-password',
    SignUpWithEmail = 'sign-up-with-email',
    TwoFactorAuth = 'two-factor-auth',
}

export enum Web3AuthPanelRenderContext {
    Teams = 'teams-referral_fantasy-wishlist-lineup-page',
}
